import { render, staticRenderFns } from "./HolidayEdit.vue?vue&type=template&id=d81cb480"
import script from "@/controllers/holiday/holiday-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/holiday/holiday-edit.js?vue&type=script&lang=js&external"
import style0 from "./HolidayEdit.vue?vue&type=style&index=0&id=d81cb480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports